import React from 'react';
import { createClientMessage } from 'react-chatbot-kit';
import { useSelector } from 'react-redux';
import { getScreenSampleQuestions } from '../../../components/Chatbot/utils';
import { useGlobalization } from '../../../contexts';
import { selectApplicationName } from '../../../selectors';
import Button from '../../Button';
import { addMessageToState } from '../utils';
const TextButton = (props) => {
    const applicationName = useSelector(selectApplicationName);
    const { t } = useGlobalization();
    const { actions, setState, payload: { screen }, } = props;
    const sampleQuestions = getScreenSampleQuestions(screen, applicationName, t);
    const handleButtonClick = (message) => {
        addMessageToState(setState, createClientMessage(message, {}));
        actions.handleMessage(message);
    };
    return (React.createElement("div", { className: "chatbot-text-buttons" }, sampleQuestions.map((message, index) => (React.createElement(Button, { key: message, color: "secondary", variant: "contained", onClick: () => handleButtonClick(message), "data-cy": `defaultText_${index}` }, message)))));
};
export default TextButton;
